import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Project, NewProject } from '@/types/projects'

// Import company APIs
import {
  getProjects as getCompanyProjects,
  createProject as createCompanyProject
} from '@/api/company/projects'

export const useProjectsStore = defineStore('projects', () => {
  // State
  const projects = ref<Project[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const createProject = async (payload: NewProject): Promise<Project | null> => {
    try {
      const response = await createCompanyProject(payload);
      const project: Project = response.data;

      // Add the new project to the start of the projects list
      projects.value.unshift(project);

      // Return the newly created project, which includes its ID
      return response.data;
    } catch (err) {
      console.error('Failed to create project:', err);
      // Return null or throw the error so the calling component knows it failed
      return null;
    }
  };
  // Action that accepts the role as an argument
  const fetchProjects = async () => {
    isLoading.value = true
    error.value = null

    try {
      const response = await getCompanyProjects()

      projects.value = response.data.data
    } catch (err) {
      error.value = 'Failed to fetch projects.'
    } finally {
      isLoading.value = false
    }
  }


  const resetStore = () => {
    // Reset state to initial values
    projects.value = []
    isLoading.value = false
    error.value = null
  }

  return {
    projects,
    isLoading,
    error,
    resetStore,
    fetchProjects,
    createProject
  }
})